export enum VebEvaluationStatus {
  ONGOING = "ongoing",
  COMPLETED = "completed",
}

export enum ProclientVebEvaluationPathology {
  NONE = "none",
  PARKINSON = "parkinson",
  ALZHEIMER = "alzheimer",
  HANDICAP = "handicap",
  NOT_COVERED = "not_covered",
  OTHER = "other",
}

export enum ProclientVebEvaluationActiveSolution {
  NONE = "none",
  SAAD = "saad",
  FAMILY_RELAY = "family_relay",
  OLDER_RESIDENCE = "older_residence",
  HOUSEWORK_SERVICE = "housework_service",
  NURSE = "nurse",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationActiveSolutionSAADReason {
  DISSATISFACTION = "dissatisfaction",
  LEFT = "left",
  HOLIDAY = "holiday",
  COMPLEMENT = "complement",
}

export enum ProclientVebEvaluationSocialEnvironment {
  NEAR_FAMILY_HELP = "near_family_help",
  DISTANT_FAMILY_HELP = "distant_family_help",
  NO_NEAR_FAMILY = "no_near_family",
  OTHER_HELPER = "other_helper",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationTriggerEvent {
  EVERYDAY_ACCIDENT = "everyday_accident",
  ILLNESS = "illness",
  MOVING_OR_HELPER_DEATH = "moving_or_helper_death",
  PARTNER_DEATH = "partner_death",
  FAMILY_REASSURANCE = "family_reassurance",
  AGING = "aging",
  NOT_COVERED = "not_covered",
  OTHER = "other",
}

export enum ProclientVebEvaluationLocation {
  HOME = "home",
  HOST_ETABLISHMENT = "host_etablishment",
  HOSPITAL = "hospital",
  OTHER = "other",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationConsideredSolution {
  HOME_SUPPORT = "home_support",
  HOST_ETABLISHMENT = "host_etablishment",
  FAMILY_RELAY = "family_relay",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationDuration {
  PERMANENT = "permanent",
  TEMPORARY = "temporary",
}

export enum ProclientVebEvaluationDurationReason {
  HOLIDAY = "holiday",
  ABSENCE_REPLACEMENT = "absence_replacement",
  EVERYDAY_ACCIDENT = "everyday_accident",
  WAITING_PLACE_FOR_ESTABLISHMENT = "waiting_place_for_establishment",
  OTHER = "other",
}

export enum ProclientVebEvaluationNeedType {
  HOUSE_KEEPING = "house_keeping",
  WASHING = "washing",
  GO_TO_BED = "go_to_bed",
  GET_OUT_OF_BED = "get_out_of_bed",
  SHOPPING = "shopping",
  MEAL_INTAKE = "meal_intake",
  MEAL_PREPARATION = "meal_preparation",
  CHANGE = "change",
  COGNITIF_STIMULATION = "cognitif_stimulation",
  PHYSICAL_STIMULATION = "physical_stimulation",
  COMPANY = "company",
  OUTING = "outing",
  DAY_CONTINUOUS_PRESENCE = "day_continuous_presence",
  NIGHT_PRESENCE = "night_presence",
}

export enum ProclientVebEvaluationPaymentMethodType {
  AUTO_DIRECT_DEBIT = "direct_debit",
  MANUAL_DIRECT_DEBIT = "manual_direct_debit",
  CESU = "cesu",
  ECESU = "ecesu",
  BANK_CHECK = "bank_check",
  TRANSFER = "transfer",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationNeedUrgency {
  URGENT = "urgent",
  SOON = "soon",
  NORMAL = "normal",
  LATER = "later",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationHelpStatus {
  HELP = "help",
  NO_HELP = "no_help",
  OTHER_HELP = "other_help",
  NOT_COVERED = "not_covered",
}

export enum ProclientVebEvaluationSalary {
  "<800" = "<800",
  "800-3000" = "800-3000",
  ">3000" = ">3000",
  NOT_COVERED = "not_covered",
}
